import '@/lib/css-style-sheet';
import css from './buttons.module.scss';

// webpack imports css modules as CSSStyleSheet, vite imports them as plain objects
const styles = css instanceof CSSStyleSheet ? css.toObject() : css;

export const base = styles['.button.default'];
export const button = base + styles['.button'];
export const md = styles['.button.md'];
export const red = styles['.button.red'];
export const paleGreen = styles['.button.pale-green'];
export const brightGreen = styles['.button.bright-green'];
export const lime = styles['.button.lime'];
